/**
 * 支付管理 升级管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>升级管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="vname" label="版本名称" width="200">
      </el-table-column>
      <el-table-column align="center" prop="vcode" label="应用版本号" width="200">
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="添加时间" width="200">
      </el-table-column>
      <el-table-column align="center" prop="downloadAddr" label="下载地址" width="200">
      </el-table-column>
      <el-table-column align="center" prop="delFlag" label="类型" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.delFlag == 1 ? '无效': '有效'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="appCode" label="应用code" width="150">
      </el-table-column>
      <el-table-column align="center" prop="updateContent" label="升级描述" width="200">
      </el-table-column>
      <el-table-column align="center" prop="forced" label="强制升级" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.timeFlag == '1'? '强制升级': '不强制升级'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="channelName" label="渠道" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.channelName == 'mi_store'">小米</div>
          <div v-else-if="scope.row.channelName == 'oppo_store'">oppo</div>
          <div v-else-if="scope.row.channelName == 'web'">web版</div>
          <div v-else-if="scope.row.channelName == 'hihonor_store'">荣耀</div>
          <div v-else-if="scope.row.channelName == 'wandoujia_store'">豌豆荚</div>
          <div v-else-if="scope.row.channelName == 'huawei_store'">华为</div>
          <div v-else-if="scope.row.channelName == 'vivo_store'">vivo</div>
          <div v-else-if="scope.row.channelName == 'tencent_store'">应用宝</div>
          <div v-else-if="scope.row.channelName == 'baidu_store'">百度</div>
          <div v-else-if="scope.row.channelName == 'flyme_store'">魅族</div>
          <div v-else-if="scope.row.channelName == '360_store'">360</div>
          <div v-else></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right"  min-width="270">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" v-if="editFormVisible" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="版本名称" prop="vname">
          <el-input size="small" v-model="editForm.vname" auto-complete="off" placeholder="请输入版本名称"></el-input>
        </el-form-item>
        <el-form-item label="应用版本号" prop="vcode">
          <el-input size="small" type="number" v-model="editForm.vcode" auto-complete="off" placeholder="请输入应用版本号"></el-input>
        </el-form-item>
        <el-form-item label="添加时间" prop="createTime">
          <el-date-picker
            v-model="editForm.createTime"
            type="date"
            @change="dateChange($event, 'createTime')"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="下载地址" prop="downloadAddr">
          <el-input size="small" v-model="editForm.downloadAddr" auto-complete="off" placeholder="请输入下载地址"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="delFlag">
          <el-select size="small" v-model="editForm.delFlag" placeholder="请选择" class="userRole">
            <el-option label="有效" :value="0"></el-option>
            <el-option label="无效" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用code" prop="appCode">
          <el-select size="small" v-model="editForm.appCode" placeholder="请选择" class="userRole">
            <el-option label="vpn" value="vpn"></el-option>
            <el-option label="aivpn" value="aivpn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级描述" prop="updateContent">
          <el-input size="small" v-model="editForm.updateContent" auto-complete="off" placeholder="请输入升级描述"></el-input>
        </el-form-item>
        <el-form-item label="强制升级" prop="forced">
          <el-select size="small" v-model="editForm.forced" placeholder="请选择" class="userRole">
            <el-option label="强制升级" :value="1"></el-option>
            <el-option label="不强制升级" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道" prop="channelName">
          <el-select size="small" v-model="editForm.channelName" placeholder="请选择" class="userRole">
            <el-option label="web版" value="web"></el-option>
            <el-option label="小米" value="mi_store"></el-option>
            <el-option label="oppo" value="oppo_store"></el-option>
            <el-option label="豌豆荚" value="wandoujia_store"></el-option>
            <el-option label="华为" value="huawei_store"></el-option>
            <el-option label="vivo" value="vivo_store"></el-option>
            <el-option label="应用宝" value="tencent_store"></el-option>
            <el-option label="百度" value="baidu_store"></el-option>
            <el-option label="魅族" value="flyme_store"></el-option>
            <el-option label="360" value="360_store"></el-option>
            <el-option label="荣耀" value="hihonor_store"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  appVersionPage, appVersionAdd, appVersionEdit, vpnVipGet, vpnVipDelete,
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      payType: [
        { key: '现金', value: 1 },
        { key: '支付宝', value: 2 },
        { key: '微信', value: 3 },
        { key: 'POS通', value: 4 },
        { key: '闪付', value: 5 },
        { key: 'POS通C扫B', value: 6 },
        { key: '银联二维码', value: 8 },
        { key: '会员余额支付', value: 9 }
      ],
      editForm: {},
      // rules表单验证
      rules: {
        vname: [
          { required: true, message: '请输入版本名称', trigger: 'blur' }
        ],
        vcode: [
          { required: true, message: '请输入应用版本号', trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: '请输入添加时间', trigger: 'blur' }
        ],
        updateContent: [
          { required: true, message: '请输入升级描述', trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: '请选择渠道', trigger: 'blur' }
        ],
        downloadAddr: [
          { required: true, message: '请输入下载地址', trigger: 'blur' }
        ],
        delFlag: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        appCode: [{ required: true, message: '请选择应用code', trigger: 'blur' }],
        forced: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dateChange(e, type){
      let date = new Date(e)
      let time = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      this.editForm[type] = time
      console.log(this.editForm[type], 'this.editForm[type]')
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
      let o = {	
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      appVersionPage(parameter)
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          } else {
            this.listData = res.data.dataList
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.totalCount
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.editForm = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.title == '添加'){
            appVersionAdd(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('套餐管理保存失败，请稍后再试！')
            })
          }else{
            appVersionEdit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('套餐管理保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vpnVipDelete({id: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('套餐管理删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    
    keyUser(index, rowItem) {
      vpnVipGet({id: rowItem.id})
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: 'res.data.msg'
            })
          }else{
            this.editFormVisible = true
            let row = res.data
            if (row != undefined && row != 'undefined') {
              this.title = '查看'
              this.editForm.id = row.id
              this.editForm.monthNum = row.monthNum
              this.editForm.priceSource = row.priceSource
              this.editForm.priceDiscount = row.priceDiscount
              this.editForm.title = row.title
              this.editForm.type = row.type
              this.editForm.px = row.px
              this.editForm.timeFlag = row.timeFlag
            }
          }
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/machine/appVersion.vue